// src/components/layouts/renderers/NewspaperFrame.tsx
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { LayoutRendererProps, NewspaperConfig } from '@/lib/layouts/types';
import { layoutHeadlineCss } from '@/lib/layouts/headlineStyle';
import { useLayerFont } from '@/hooks/use-layer-font';

const SERIF = 'Georgia, "Times New Roman", serif';
const SANS = 'system-ui,-apple-system,sans-serif';

export const NewspaperFrame: React.FC<LayoutRendererProps<NewspaperConfig>> = ({ config, media }) => {
  useLayerFont(config.headlineFontFamily, config.headlineFontUrl);
  return (
    <AbsoluteFill style={{ backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', padding: 60 }}>
      <div style={{ borderBottom: `4px solid ${config.accentColor}`, paddingBottom: 14, marginBottom: 24, flexShrink: 0 }}>
        <div style={{ fontFamily: SERIF, fontSize: 56, fontWeight: 700, color: config.accentColor, letterSpacing: 1 }}>{config.sourceName}</div>
      </div>
      <div
        data-testid="layout-headline"
        data-autocut-over=""
        style={{
          fontWeight: 700,
          lineHeight: 1.2,
          marginBottom: 12,
          flexShrink: 0,
          ...layoutHeadlineCss(config, { color: '#111', fontSize: 60, fontFamily: SERIF }),
        }}
      >
        {config.headline}
      </div>
      {config.kicker ? <div style={{ fontFamily: SANS, fontSize: 30, color: '#666', marginBottom: 28, flexShrink: 0 }}>{config.kicker}</div> : null}
      <div style={{ flex: 1, minHeight: 0, width: '100%', overflow: 'hidden', backgroundColor: '#000', position: 'relative' }}>{media}</div>
    </AbsoluteFill>
  );
};
